module.exports = __webpack_public_path__ + "img/0b93ba3.png";